export interface VAutoFocusBinding {
  active?: boolean;
  delay?: number;
}

export default {
  inserted(el: any, { value }: { value: boolean | VAutoFocusBinding }) {
    setTimeout(
      () => {
        if (el && el.focus) {
          if (typeof value === "boolean") {
            if (value) el.focus();
          } else if (value?.active ?? true) el.focus();
        }
      },
      typeof value !== "boolean" ? value?.delay ?? 0 : 0
    );
  },
};
